import Image from 'next/legacy/image';
import { MarkDown } from '@sy/component-library';
import type { MarkDownComponents } from '@sy/component-library';

import Anchor from '~/components/Anchor';
import {
	DescriptionWrapper,
	InfoCardContent,
	InfoCardWrapper,
	Title,
	TitlesColumn,
	TitleAndDescriptionWrapper,
	Highlight,
	HighlightWrapper,
	HighlightsColumn,
	StyledListItem,
	StyledParagraph,
	StyledUnorderedList,
	TextImageWrapper,
} from './CaseStudyInfoCard.styles';
import star from './star.svg';

const components = {
	a: Anchor,
	li: StyledListItem,
	p: StyledParagraph,
	ul: StyledUnorderedList,
} as MarkDownComponents;

const Star = () => (
	<TextImageWrapper>
		<Image
			src={star}
			alt=""
			layout="fill"
			objectFit="contain"
			objectPosition="top"
		/>
	</TextImageWrapper>
);

const TitleAndDescription = ({
	title,
	description,
}: {
	title?: string;
	description?: string;
}) => {
	if (!title || !description) return null;
	return (
		<TitleAndDescriptionWrapper>
			<Title>{title}</Title>
			<DescriptionWrapper>
				<MarkDown components={components} content={description} />
			</DescriptionWrapper>
		</TitleAndDescriptionWrapper>
	);
};

const CaseStudyInfoCard = ({
	title1,
	title2,
	title3,
	description1,
	description2,
	description3,
	highlight1,
	highlight2,
	highlight3,
}: CaseStudyInfoCardProps) => {
	return (
		<InfoCardWrapper>
			<InfoCardContent>
				<TitlesColumn>
					<TitleAndDescription title={title1} description={description1} />
					<TitleAndDescription title={title2} description={description2} />
					<TitleAndDescription title={title3} description={description3} />
				</TitlesColumn>
				<HighlightsColumn>
					{highlight1 && (
						<HighlightWrapper>
							<Star />
							<Highlight>{highlight1}</Highlight>
						</HighlightWrapper>
					)}
					{highlight2 && (
						<HighlightWrapper>
							<Star />
							<Highlight>{highlight2}</Highlight>
						</HighlightWrapper>
					)}
					{highlight3 && (
						<HighlightWrapper>
							<Star />
							<Highlight>{highlight3}</Highlight>
						</HighlightWrapper>
					)}
				</HighlightsColumn>
			</InfoCardContent>
		</InfoCardWrapper>
	);
};

export type CaseStudyInfoCardProps = {
	title1?: string;
	title2?: string;
	title3?: string;
	description1?: string;
	description2?: string;
	description3?: string;
	highlight1?: string;
	highlight2?: string;
	highlight3?: string;
};

export default CaseStudyInfoCard;
